/**************************************************
 * Nombre:       Tarjeta_Funnel_Pq
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Detalle_Campana from "../Dialogos/Dialogo_Detalle_Campana";
import {useEffect, useRef} from "react";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";

const Tarjeta_Funnel_Pq = ({item}) => {
    let refe = useRef('')
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Detalle_Campana, titulo: 'Detalles de Campaña'})
    const {alto} = useObtenerAlto({contenedor: refe})

    useEffect(() => {
        console.log(item)
    }, [item])
    return (
        <Grid
            ref={refe}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 0,
                border: 1,
                borderColor: theme.palette.primary.main + 30

            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={4}
                sx={{
                    backgroundImage: `url(${item.img})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    p: 1,
                    height: alto
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

                </Grid>

            </Grid>

            <Grid

                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={8}
                sx={{
                    px: 2,
                    py: 1
                }}
                spacing={1}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>{item.nombreFunnel}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Typography sx={{fontWeight: 300, fontSize: 12, lineHeight: 1.2}}>{item.descripcion} </Typography>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Funnel_Pq